import React from 'react';

const WelcomeSection = () => (
  <section className="mb-6">
    <h2 className="text-xl font-bold mb-2">Dashboard Overview</h2>
  </section>
);

export default WelcomeSection; 